import { jsx as _jsx } from "react/jsx-runtime";
import CardPrice from "./CardPrice";
const CardPricePreview = () => {
    return (_jsx(CardPrice, { surtitle: "Tarif", title: "15,99 \u20AC", titleComplement: "HT / poste / mois" }));
};
export default CardPricePreview;
